var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiFaceOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "70px",
    height: "80px",
    viewBox: "0 0 70 80",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M40.021,75.272c-3.176-1.434-6.814-1.434-9.99,0c0-1.861,0-3.723,0-5.584c3.176-1.434,6.814-1.434,9.99,0 C40.021,71.55,40.021,73.411,40.021,75.272z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 35.059,
    y1: 38.848,
    x2: 35.059,
    y2: 19.674
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 35.058,
    cy: 18.93,
    r: 3.165
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M22.586,53.417c0,2.499-2.044,4.543-4.542,4.543h-3.202c-2.499,0-4.542-2.044-4.542-4.543v-6.551 c0-2.499,2.044-4.542,4.542-4.542h3.202c2.499,0,4.542,2.044,4.542,4.542V53.417z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M22.586,53.417c0,2.499-2.044,4.543-4.542,4.543h-3.202c-2.499,0-4.542-2.044-4.542-4.543v-6.551c0-2.499,2.044-4.542,4.542-4.542 h3.202c2.499,0,4.542,2.044,4.542,4.542V53.417z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M59.816,53.417c0,2.499-2.044,4.543-4.542,4.543h-3.201c-2.499,0-4.542-2.044-4.542-4.543v-6.551 c0-2.499,2.044-4.542,4.542-4.542h3.201c2.499,0,4.542,2.044,4.542,4.542V53.417z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M59.816,53.417c0,2.499-2.044,4.543-4.542,4.543h-3.201c-2.499,0-4.542-2.044-4.542-4.543v-6.551c0-2.499,2.044-4.542,4.542-4.542 h3.201c2.499,0,4.542,2.044,4.542,4.542V53.417z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M54.055,64.723c0,2.322-1.9,4.222-4.222,4.222h-29.55c-2.322,0-4.222-1.899-4.222-4.222V35.172 c0-2.322,1.9-4.222,4.222-4.222h29.55c2.322,0,4.222,1.9,4.222,4.222V64.723z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M54.055,64.723c0,2.322-1.9,4.222-4.222,4.222h-29.55c-2.322,0-4.222-1.899-4.222-4.222V35.172c0-2.322,1.9-4.222,4.222-4.222 h29.55c2.322,0,4.222,1.9,4.222,4.222V64.723z"
  })), /*#__PURE__*/React.createElement("image", {
    width: 45,
    height: 159,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAACjCAYAAADIBU1XAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAlhJREFUeNrs3dFOwkAQheFC64Uk RH0BY3z/ZyKEaxM1JpqgBLfYC8SybLe7OzP1b0JMJIV+nDPbwk2raiLbbOgOj/cPtfuz6Hlqt9qs 36UgTQTgHGTrHrohHWJ5BqBia0amYAPSPb+0MOzzC2lcW1m15lZnIjSRxhKiF2KtUr5EzKXxB2I1 jb5ETKbhXX6BGIfsJC8Yk0IkL+GpFhAgQIAAAQKkf6vdd5nFJCDS32OoFhAgQIAAAQIECBAgQIAA ATJ9iOgvKUkhleAvKVQLCBAgQIAAAaLweis5ROp6i2oBAQIEyGQgIifFLBCJkyLVAgIEiK0lOBuk 9BJMtYAAkYMUXbmyQkquXFQLCBBZSLGVKzuk1MpFtYAYhhQZ+CKQEgNPtYAYh2Qf+GKQ3ANPtYBM AJJ14ItCcg481frvkGxzUhySa06oFpBMcyICyTEnVEtbvcQgqetFtYBkmhNRSMo5oVra6iUOSVUv qqWtXiogKepFtbTVSw1kbL2olrZ6qYKMqZe2akWnog4SmwrDrq1eKiEx9dJarcGpqIUMTYVh11Yv 1ZAh9dJereBU1ENCU7Ew7EGpmICEpHIK+aqE77UTm8ovyGqzbm8a9GExFUsnRG8qfRC19fKlUp/+ 4/n1ZX93c/vZIa+0adyx7d0xfgZVy+Ks+GbE1Ap2FtKl8qYQ05tK7dtD87yczkp9aYcjzL76uTmd BtDhgz3G1CF7tRj32CoDtZi5O65D9Wcxr6DoDsiHOW7v/Dcb8yqeO4OX/AVl6yBPzZh3PVrZkmzd B7OLSIVN3fYtwABs63QGj+OMEQAAAABJRU5ErkJggg==",
    transform: "matrix(0.24 0 0 0.24 16.0615 31.0918)"
  }), /*#__PURE__*/React.createElement("image", {
    width: 27,
    height: 65,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAABHCAYAAAD7hkyeAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAS1JREFUeNrs2e8KgjAQAHBdE/oQ qS8Q0fs/k4gvoPYhKbO6xZSVmvPPHUh3cASx7ee5Px+m4/xLuGM7nA5HD36EZfMySuLHZNTA9pCe ZbccsviGNyPAAHJn20fHFrIK/aBK8+xpjRqgN3EKW7BABuvwzTEEAdgKYft06Kiu0l3YkjCu6EQR X2vz5gTVPHa+XiqwQSlBs1KfChw8HBhllNEWinS4D1ZKejDwQmKUUUYZZZTRWVFCPqjRc5TEJc8p o+tHm/1DhsLeUZeGd55TRleLkm6bN0q9bXghkaFki6lB9WIqIG/Y+Md3mTTPrpCX0A/U/9JZ9qqn gLGr3jnFrrr3CxRC1b8rxa5a2jTSsLrr77pdk2O3nhzTuMbN6HmQWc4ioR5MX3xy4MdLgAEAdVFo BKmut8MAAAAASUVORK5CYII=",
    transform: "matrix(0.24 0 0 0.24 10.2329 42.4077)"
  }), /*#__PURE__*/React.createElement("image", {
    width: 22,
    height: 26,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAdCAYAAABfeMd1AAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQVJREFUeNq8lgsKwjAMhtvUCRaG egGR3f9MIl5ARZiMKbOVDLbulSbbAmWPsnz9/6UPpVYIPdaZnc7WXSw+5pfbNedANhOA1DWDrwqu EiACRAFLAzqQJQB9SswIwOIg+JCgkvrCcBXCHElY1TUSLMtiISy1wFAfrYYDiVYDzH8ZpYYL8UpS KggElUm2DYRTgGSbFEKyDWaY0JOgJiTHNjtIB0t9iks9N77YWlt1aJdETa1oG6pqleD9+aiO+0OJ 8ES48CYuV+VylnpgjzdomxUWhbfu1Vtdzs9/p9C6+oRTTJ27DB6bdhGq/MDeeP/xA9aUrxowNQDs JCafIAlANZR49fgJMABtdz8VDmFTVQAAAABJRU5ErkJggg==",
    transform: "matrix(0.24 0 0 0.24 31.8047 16.0352)"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.3839,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 40.021,
    y1: 69.688,
    x2: 40.021,
    y2: 75.272
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.3839,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 30.03,
    y1: 75.272,
    x2: 30.03,
    y2: 69.688
  }), /*#__PURE__*/React.createElement("image", {
    width: 42,
    height: 28,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAhCAYAAACm75niAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAMFJREFUeNrs2EEKhSAUBVAfRUEg 1Qbi0/7X9Im24CghyEGDfunnKVoJ90I4KTgXQ/AVItMUgN8cCvloHD61WarIFv2dpyUq3AJNAjfP wi1CTGwKqE+RSwn6A34Cyy5BFrR8EdhVQv2cKn3bNWZpMjgJ1zO83n+Rt0cDDjjggAMOOOCAAw44 4IB7w8sEYwXfBF3KywhIr0GOZaqgRcDM5nzLl/stnz3fiB3m8Em54LdimUWOBRQ5XnoUy9gJLXLN JsAAllJVIkiqp4wAAAAASUVORK5CYII=",
    transform: "matrix(0.24 0 0 0.24 30.0303 68.6133)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M29.679,44.37c-0.501-0.71-1.319-1.178-2.256-1.178c-0.935,0-1.753,0.468-2.255,1.178"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D1D1B",
    cx: 27.424,
    cy: 48.403,
    r: 1.985
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M44.882,44.37c-0.502-0.71-1.319-1.178-2.256-1.178c-0.935,0-1.753,0.468-2.255,1.178"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1D1D1B",
    cx: 42.627,
    cy: 48.403,
    r: 1.985
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.4981,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M30.186,57.897c3.154,0.97,6.526,0.97,9.68,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M45.081,14.481c-0.412-1.462-1.188-2.842-2.339-3.991c-1.216-1.217-2.691-2.011-4.247-2.401"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M39.759,4.812c2.023,0.517,3.942,1.553,5.525,3.137c1.518,1.518,2.537,3.341,3.074,5.27"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M41.805,15.745c-0.288-0.993-0.82-1.931-1.604-2.714c-0.849-0.849-1.882-1.399-2.97-1.665"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M38.495,8.089c1.556,0.391,3.031,1.185,4.247,2.401c1.15,1.149,1.927,2.529,2.339,3.991"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M37.231,11.366c1.088,0.266,2.121,0.816,2.97,1.665c0.783,0.783,1.315,1.721,1.604,2.714"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiFaceOn);
export default __webpack_public_path__ + "static/media/ai-face-on.b86653720a2c2b21dbb9fbc193ad0b55.svg";
export { ForwardRef as ReactComponent };